import { ActionSource } from 'owa-mail-store';
import { SurfaceActionItem } from 'owa-surface-actions';

export default function getActionSource(
    item: SurfaceActionItem,
    actionSourceInProps: ActionSource
): ActionSource {
    let actionSource: ActionSource = 'RPCSAPinned';
    if (item?.renderedInOverflow) {
        // If the item is rendered in the overflow, it either wasn't pinned to begin with or
        // was moved to the overflow due to limited space.
        if (item.isPinned) {
            actionSource = 'RPCSAOverflow';
        } else {
            actionSource = 'RPCSANotPinned';
        }
    }

    // Use the action source in props
    if (actionSourceInProps) {
        actionSource = actionSourceInProps;
    }

    return actionSource;
}
